





































import {Component, Vue, Watch} from 'vue-property-decorator';
import axios from 'axios';

@Component({
    components: {},
})
export default class Samples extends Vue {
    public loading = true;

    public error = false;
    public errorText = "";

    public items = [];
    public headers = [
        {
            text: 'Name',
            sortable: true,
            value: 'name',
        },
        {
            text: 'Location',
            sortable: false,
            value: 'locationLink',
        },
        {
            text: 'Link',
            sortable: false,
            value: 'link',
        },
    ];

    public pagination = {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        totalPages: 0,

        rowsPerPageItems: [10, 20, 50, 100,],
    };

    @Watch('pagination', {deep: true})
    public onPaginationHandler(val: any, oldVal: any) {
        if (val.page !== oldVal.page || val.rowsPerPage !== oldVal.rowsPerPage) {
            this.loadData();
        }
    }

    // noinspection JSUnusedLocalSymbols
    private async created() {
        await this.loadData();
    }

    private async loadData() {
        this.loading = true;
        this.error = false;

        try {
            const response = await axios.get('/samples?projection=summary&page=' +
                (this.pagination.page - 1) + '&size=' + this.pagination.rowsPerPage);

            this.items = response.data._embedded.samples;
            this.pagination.page = response.data.page.number + 1;
            this.pagination.rowsPerPage = response.data.page.size;
            this.pagination.totalItems = response.data.page.totalElements;
            this.pagination.totalPages = response.data.page.totalPages;
        } catch (e) {
            console.log(JSON.stringify(e));

            this.error = true;
            this.errorText = e.message + ', ' + e.config.url;
        }

        this.loading = false;
    }
}
